/** Shown when a minor attempts delete/archive/reject/offload-delete actions. */
export const MINOR_MESSAGE_MUTATION_BLOCKED =
  'Minor accounts cannot delete or archive messages. A parent account manages message retention.';
